import { http } from "./Config";
import settings from "@/settings";
export default {
  
  get: () => {
    return http.get(
        "api/isapi.dll/syspedgetcliente" +
        "?empresa=" +
        settings.usuarioAutenticado.EMPRESA +
        "&cliente=" +
        settings.usuarioAutenticado.CLIENTE
    );
  },
};
